import { BuyerType } from "@/framework/billing/stripe";
import FormControlLabel from "@mui/material/FormControlLabel";
import MenuItem from "@mui/material/MenuItem";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { countryOptions } from "./buyerCountryOptions";

export type BuyerSelection = {
  buyerType: BuyerType;
  // Empty while the buyer has not picked a country yet.
  countryCode: string;
};

type BuyerTypeCountryFieldsProps = BuyerSelection & {
  onChange: (selection: BuyerSelection) => void;
};

// Buyer type radios plus the country dropdown, whose options depend on the
// buyer type. Shared by the topup form and the public pricing page.
export const BuyerTypeCountryFields = ({
  buyerType,
  countryCode,
  onChange,
}: BuyerTypeCountryFieldsProps) => {
  // The country list is the same for both buyer types, so the chosen country
  // survives a buyer type switch even when the combination is unsupported.
  const changeBuyerType = (newBuyerType: BuyerType) =>
    onChange({ buyerType: newBuyerType, countryCode });

  return (
    <>
      <RadioGroup
        row
        value={buyerType}
        onChange={(event) => changeBuyerType(event.target.value as BuyerType)}
        sx={{ my: 2, alignItems: "center" }}
      >
        <Typography variant="body1" sx={{ mr: 2 }}>
          Purchasing as a
        </Typography>
        <FormControlLabel
          value="private"
          control={<Radio size="small" />}
          label="Private individual"
        />
        <FormControlLabel
          value="business"
          control={<Radio size="small" />}
          label="Business"
        />
      </RadioGroup>

      <TextField
        select
        label="Country"
        value={countryCode}
        onChange={(event) =>
          onChange({ buyerType, countryCode: event.target.value })
        }
        size="small"
        fullWidth
        sx={{ mb: 2 }}
      >
        {countryOptions.map((option) => (
          <MenuItem key={option.countryCode} value={option.countryCode}>
            {option.label}
          </MenuItem>
        ))}
      </TextField>
    </>
  );
};
